export default __webpack_public_path__ + "static/media/typescript.af108db0.png";